<script lang="ts">
    /**
     * Zeichen aus dem SVG-Sprite des Themes.
     *
     * ⚠️ Ersetzt `IconFont`: die Icon-SCHRIFT, die dort nachgeschlagen wurde, gibt es im
     * OXID-7-Stand nicht mehr (Christoph, 2026-09-16) — die Komponenten zeigten deshalb
     * leere Kaestchen. Das Theme liefert seine Zeichen als Sprite, und seit die Modals
     * ohne Shadow DOM laufen, ist dieses Sprite auch aus ihnen erreichbar.
     *
     * Die Namen sind dieselben wie bei IconFont (down, basket, arrow-right, size …),
     * deshalb war beim Umstellen keine Uebersetzung noetig.
     */
    let {
        name,
        class: className = '',
        width = 20,
        height = 20,
        'aria-label': ariaLabel = null,
    }: {
        name: string;
        class?: string;
        width?: number | string;
        height?: number | string;
        'aria-label'?: string | null;
    } = $props();
</script>

<svg {width} {height} class={className} fill="currentColor"
     role={ariaLabel ? 'img' : undefined}
     aria-label={ariaLabel ?? undefined}
     aria-hidden={ariaLabel ? undefined : 'true'}
     focusable="false"><use xlink:href={`#${name}`}></use></svg>
